import React from 'react'
import {Checkbox} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CheckIcon from '@material-ui/icons/Check'
import './StatusSelect.scss'

const RootClass = 'c-status-select'

const StatusSelect = ({options, value, onChange}) => {
  const handleClick = (e, data) => {
    let _value = [...value]
    const index = value.indexOf(data.id)
    if (index !== -1) {
      _value.splice(index, 1)
    } else {
      _value.push(data.id)
    }
    onChange(e, _value)
  }
  return (
    <div className={`${RootClass}`}>
      <div className={`${RootClass}__wrapper ap-scrollbar`}>
        {options.map(o => {
          return (
            <StatusOption
              data={o}
              selected={value.indexOf(o.id) !== -1}
              onClick={handleClick}
              isDisabled={o.isDisabled}
            />
          )
        })}
      </div>
    </div>
  )
}

const StatusOption = ({data, selected, onClick, isDisabled = false}) => {
  return (
    <div
      className={`c-res-mod ap-typography ap-typography--sm ${RootClass}__option ${
        selected ? `${RootClass}__option--selected` : null
      } ${isDisabled ? `${RootClass}__option--disabled` : ''}`}
      onClick={!isDisabled ? e => onClick(e, data) : null}
      title={data.name}
    >
      <div className={`${RootClass}__option-icon`}>
        {selected && <CheckIcon style={{color: '#fff', width: 14.5}} />}
      </div>
      <div className={`${RootClass}__option-cell ap-ellipsis`}>{data.name}</div>
    </div>
  )
}

export default StatusSelect
